import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PieCobranzasMensualesPorEmpresa from '../PieCobranzasMensualesPorEmpresa/PieCobranzasMensualesPorEmpresa';
import TablaMultiempresa from '../TablaMultiempresa/TablaMultiempresa';
import { fechaInicioPeriodoMesActualFunc, fechaFinPeriodoMesActualFunc } from '../../../../shared/fechas';
import { storageMonedaSigno } from '../../../../shared/sessionData';
import { formatNumber } from '../../../../shared/formatNumber';

import * as actions from '../../../../store/actions/index';

const MultiChartCobranzasMensualesPorEmpresa = (props) => {
    const [viewAsPie, setViewAsPie] = useState(true);

    useEffect(() => {
        if (!props.estaCargado && !props.estaOculto && props.ejecucionDePagina) 
          props.onLoadChart();
        
    }, [props.ejecucionDePagina]);
    
    const handleChangeView = () => {
        setViewAsPie(!viewAsPie)
    }

    return(
        viewAsPie 
        ? 
            <PieCobranzasMensualesPorEmpresa 
                ejecucionDePagina={props.ejecucionDePagina}
                onPorcionClick={props.onPorcionClick}
                onChangeViewClick={handleChangeView}
                title={`Cobranzas mensuales por empresa ${fechaInicioPeriodoMesActualFunc()} al ${fechaFinPeriodoMesActualFunc()}`}
                subtitle={`Total: ${storageMonedaSigno()} ${formatNumber(props.totalCobranzas)}`}
                height={300}
                width={'100%'}
            />
        : 
            <TablaMultiempresa 
                empresas={props.cobranzas}
                onChangeViewClick={handleChangeView}
                title={`Cobranzas mensuales por empresa ${fechaInicioPeriodoMesActualFunc()} al ${fechaFinPeriodoMesActualFunc()}`}
                subtitle={`Total: ${storageMonedaSigno()} ${formatNumber(props.totalCobranzas)}`}
                height={245}
                width={'100%'}
            />
    )
}

const mapStateToProps = (state) => {
    return {
      cobranzas: state.multiempresa.cobranzasMensualesPorEmpresa.cobranzas,
      totalCobranzas: state.multiempresa.cobranzasMensualesPorEmpresa.totalCobranzas,
      loading: state.multiempresa.cobranzasMensualesPorEmpresa.loading,
      estaCargado: state.multiempresa.cobranzasMensualesPorEmpresa.estaCargado,
      estaOculto: state.configuraciones.indicadoresOcultosPorUsuario.indicadores.cobranzasMensualesMultiempresa
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLoadChart: () => dispatch(actions.loadCobranzasMensualesPorEmpresa())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MultiChartCobranzasMensualesPorEmpresa);